import { render } from "./template-incorporation-form-step-1.vue?vue&type=template&id=518d299b"
import script from "./template-incorporation-form-step-1.vue?vue&type=script&lang=js"
export * from "./template-incorporation-form-step-1.vue?vue&type=script&lang=js"

import "./template-incorporation-form-step-1.vue?vue&type=style&index=0&id=518d299b&lang=less"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__